import { Injectable } from '@angular/core';
import { ApplicationRouterService } from './application-router/application-router.service';
import { RouteExecutor } from './application-router/route.executor';

@Injectable({
    providedIn: 'root',
})
export class MediaCDNService extends RouteExecutor {
    constructor(public applicationRouterService: ApplicationRouterService) {
        super(applicationRouterService);
    }

    getImageCDN(): string {
        const mobileWeb =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            );
        if (mobileWeb) {
            return '?tr=cm-pad_crop,w-385,dpr-2';
        } else return '?tr=cm-pad_crop,w-785,dpr-2';
    }

    getVideoCDN(): string {
        const mobileWeb =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            );
        if (mobileWeb) {
            return `,f-webm,w-430`;
        } else return `,f-webm,w-1440`;
    }
}
